import { useState } from "react";
import { CheckCircle, XCircle, Edit3 } from "lucide-react";
import api from "../../services/api";

var SOURCE_LABELS = {
  consorcio: "Consorcio", carta_contemplada: "Carta Contemplada",
  seguro_vida: "Seguro Vida", seguro_residencial: "Seguro Residencial",
  seguro_auto: "Seguro Auto", plano_saude: "Plano Saude",
  manual: "Manual", cashback: "Cashback", doacao: "Doacao",
};

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }
function fmtR(v) { return v == null ? "R$ 0,00" : "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2 }); }

function PendingRow({ tx, onRefresh }) {
  var _editing = useState(false);
  var editing = _editing[0];
  var setEditing = _editing[1];
  var _editAmt = useState("");
  var editAmt = _editAmt[0];
  var setEditAmt = _editAmt[1];

  async function handleApprove() {
    try {
      await api.put("/doletas/transactions/" + tx.id + "/approve");
      if (onRefresh) onRefresh();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    }
  }

  async function handleReject() {
    var reason = prompt("Motivo da rejeicao (opcional):");
    if (reason === null) return;
    try {
      await api.put("/doletas/transactions/" + tx.id + "/reject", { reason: reason });
      if (onRefresh) onRefresh();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    }
  }

  async function handleEdit() {
    var val = parseFloat(editAmt);
    if (isNaN(val) || val <= 0) { alert("Valor invalido"); return; }
    try {
      await api.put("/doletas/transactions/" + tx.id + "/edit", { amount: val });
      setEditing(false);
      if (onRefresh) onRefresh();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    }
  }

  var typeCls = tx.type === "earn" ? "bg-emerald-100 text-emerald-700" : tx.type === "redeem" ? "bg-blue-100 text-blue-700" : "bg-purple-100 text-purple-700";
  var typeLabel = tx.type === "earn" ? "Ganho" : tx.type === "redeem" ? "Resgate" : "Doacao";

  return (
    <tr className="hover:bg-gray-50 transition-colors" data-testid={"pending-row-" + tx.id}>
      <td className="px-4 py-3">
        <p className="font-medium text-[#0A2F3D]">{tx.user_name}</p>
        <p className="text-xs text-gray-400">{tx.user_role === "broker" ? "Vendedor" : "Cliente"}</p>
      </td>
      <td className="px-4 py-3"><span className={"px-2 py-1 text-xs font-medium rounded-full " + typeCls}>{typeLabel}</span></td>
      <td className="px-4 py-3 text-gray-600">{SOURCE_LABELS[tx.source] || tx.source}</td>
      <td className="px-4 py-3 text-gray-600 max-w-[200px] truncate">{tx.source_description}</td>
      <td className="px-4 py-3 text-right text-gray-600">{fmtR(tx.original_value)}</td>
      <td className="px-4 py-3 text-right">
        {editing ? (
          <div className="flex items-center gap-1 justify-end">
            <input type="number" value={editAmt} onChange={function (e) { setEditAmt(e.target.value); }}
              className="w-24 px-2 py-1 border rounded text-right text-sm" autoFocus />
            <button onClick={handleEdit} className="p-1 text-emerald-600 hover:bg-emerald-50 rounded"><CheckCircle className="w-4 h-4" /></button>
            <button onClick={function () { setEditing(false); }} className="p-1 text-gray-400 hover:bg-gray-100 rounded"><XCircle className="w-4 h-4" /></button>
          </div>
        ) : (
          <span className="font-semibold text-[#0A2F3D]">{fmt(tx.amount)}</span>
        )}
      </td>
      <td className="px-4 py-3 text-right text-emerald-600 font-medium">{fmtR(tx.money_value)}</td>
      <td className="px-4 py-3 text-gray-500">{tx.multiplier_applied !== 1 ? "x" + tx.multiplier_applied : "-"}</td>
      <td className="px-4 py-3">
        <div className="flex items-center justify-center gap-1">
          <button onClick={handleApprove} className="p-1.5 text-emerald-600 hover:bg-emerald-50 rounded-lg" title="Aprovar" data-testid={"btn-approve-" + tx.id}><CheckCircle className="w-4 h-4" /></button>
          <button onClick={handleReject} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg" title="Rejeitar" data-testid={"btn-reject-" + tx.id}><XCircle className="w-4 h-4" /></button>
          <button onClick={function () { setEditing(true); setEditAmt(String(tx.amount)); }} className="p-1.5 text-blue-500 hover:bg-blue-50 rounded-lg" title="Editar" data-testid={"btn-edit-" + tx.id}><Edit3 className="w-4 h-4" /></button>
        </div>
      </td>
    </tr>
  );
}

export default function DoletasPendingTable({ pending, total, loading, onRefresh }) {
  if (loading) {
    return <div className="bg-white rounded-xl border border-gray-200 flex items-center justify-center py-12"><div className="w-6 h-6 border-2 border-[#3B82F6] border-t-transparent rounded-full animate-spin" /></div>;
  }

  var rows = [];
  for (var i = 0; i < pending.length; i++) {
    rows.push(<PendingRow key={pending[i].id} tx={pending[i]} onRefresh={onRefresh} />);
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100">
        <h3 className="font-semibold text-[#0A2F3D] text-sm">Transacoes Pendentes ({total})</h3>
      </div>
      {pending.length === 0 ? (
        <div className="py-12 text-center text-gray-400 text-sm">Nenhuma transacao pendente</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Usuario</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Tipo</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Fonte</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Descricao</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-right">Valor Original</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-right">Doletas</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-right">R$ Equiv.</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Mult.</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-center">Acoes</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">{rows}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
